import React, { useContext, useEffect, useState } from 'react'
import PageTitle from '../../Utility/PageTitle'
import { Avatar, Button, Card, Divider, Image, Modal, Tag } from 'antd'
import { ArrowLeftOutlined, CheckCircleTwoTone, CloseCircleTwoTone, DownloadOutlined, LoadingOutlined, SolutionOutlined } from '@ant-design/icons'
import { Link, useNavigate, useParams } from 'react-router-dom';
import { formatDate, getStatusTag, getApplicationId } from '../../Utility/Functions';
import { useFetch } from '../../../services/ApiService';
import PDFViewer from '../../Utility/PDFViewer';

function ApplicationDetails({ data, loading, getData, refreshData }) {

    const [showPreview, setShowPreview] = useState(false);
    const [previewURL, setPreviewURL] = useState(null);
    const [previewTitle, setPreviewTitle] = useState(null);
    const [isPdf, setIsPdf] = useState(false);
    const [isImage, setIsImage] = useState(false);
    

    const navigate = useNavigate();

    const handleFileDownload = (url, title) => {
        const getFileExt = url.slice((url.lastIndexOf(".") - 1 >>> 0) + 2);

        if (getFileExt.toLowerCase() === 'pdf')  {
            setIsPdf(true)
        }
        else if (getFileExt.toLowerCase() === 'jpg' || getFileExt.toLowerCase() === 'png' || getFileExt.toLowerCase() === 'jpeg')  {
            setIsImage(true);
        }
        else {
            window.open(url, '_blank');
            return false
        }
        setShowPreview(true);
        setPreviewURL(url);
        setPreviewTitle(title);
    }

    const downloadCertificateButtons = [
        {
            title: 'Educational Certificates',
            url: data.edu_cert_url
        },
        {
            title: 'Experience Certificates',
            url: data.exp_cert_url
        },
        {
            title: 'Training Certificates',
            url: data.training_cert_url
        },
        {
            title: 'Other Certificates',
            url: data.other_cert_url
        }]

    const handleClose = () => {
        setShowPreview(false);
        setIsImage(false);
        setIsPdf(false);
    }


    

    return (
        <>
            <Card
                loading={loading}
                title={
                    <div className='avatar-user'>
                        {/* <Avatar size={64} src={data.image_url} /> */}
                        <Image
                            width={64}
                            src={data.image_url}
                        />
                        <div className='avatar-user-info'>
                            <h5>{data.candidate_name}</h5>
                            {!loading && <p>UID: {data.aadhar_number}</p>}
                        </div>
                    </div>
                }
                extra={
                    <>
                        {!loading &&
                            < div className='text-muted'>
                                Type:
                                {
                                    data.application_type === 'new' ?
                                        <Tag className='ms-1 px-sm-3 py-1 h6 mt-2' color="blue">New</Tag> :
                                        <Tag className='ms-1 px-sm-3 py-1 h6 mt-2' color="#E34031">Re-Application</Tag>
                                }
                                {/* <Button className='mb-0 ms-2' type='primary' onClick={() => navigate(`/create-application/edit/${data.id}`)}>Edit Details</Button> */}
                            </div>
                        }
                    </>
                }
            >
                <div className="row">
                    <div className="col-md-8">
                        <h3 class="text-primary fw-semibold mb-3"><span>Candidate Information</span></h3>
                        <div className='candidate-view'>
                            <div className='candidate-view-info'>
                                <div className='candidate-view-label'>Application Date</div>
                                <div className='candidate-view-value'>{formatDate(data.application_date)}</div>
                            </div>
                            <div className='candidate-view-info'>
                                <div className='candidate-view-label'>Application Number</div>
                                <div className='candidate-view-value'>{getApplicationId(data.id)}</div>
                            </div>
                            {/* <div className='candidate-view-info'>
                                <div className='candidate-view-label'>Candidate Employee No.</div>
                                <div className='candidate-view-value'>{data.candidate_number}</div>
                            </div>
                            <div className='candidate-view-info'>
                                <div className='candidate-view-label'>Contract Expiry Date</div>
                                <div className='candidate-view-value'>{data.contract_expiration_date && formatDate(data.contract_expiration_date)}</div>
                            </div> */}
                            <div className='candidate-view-info'>
                                <div className='candidate-view-label'>Candidate Name</div>
                                <div className='candidate-view-value'>{data.candidate_name}</div>
                            </div>
                            <div className='candidate-view-info'>
                                <div className='candidate-view-label'>Date of Birth</div>
                                <div className='candidate-view-value'>{formatDate(data.dob)}</div>
                            </div>
                            <div className='candidate-view-info'>
                                <div className='candidate-view-label'>Gender</div>
                                <div className='candidate-view-value' style={{ textTransform: 'capitalize' }}>{data.gender}</div>
                            </div>
                            <div className='candidate-view-info'>
                                <div className='candidate-view-label'>Employment Category</div>
                                <div className='candidate-view-value' style={{ textTransform: 'capitalize' }}>{data.employment_category}</div>
                            </div>
                            <div className='candidate-view-info'>
                                <div className='candidate-view-label'>State</div>
                                <div className='candidate-view-value'>{data.states}</div>
                            </div>

                            <div className='candidate-view-info'>
                                <div className='candidate-view-label'>Trade</div>
                                <div className='candidate-view-value'>{data.job_trade}</div>
                            </div>
                            <div className='candidate-view-info'>
                                <div className='candidate-view-label'>Candidate Qualification</div>
                                <div className='candidate-view-value'>{data.qualification}</div>
                            </div>
                            <div className='candidate-view-info'>
                                <div className='candidate-view-label'>Experience (in years)</div>
                                <div className='candidate-view-value'>{data.years_of_experience}</div>
                            </div>
                        </div>

                        <h3 class="text-primary fw-semibold mb-3 mt-5"><span>Certificates</span></h3>
                        {/* <div className='candidate-view'>
                            <div className='candidate-view-info'>
                                <div className='candidate-view-label'>Educational Certificates</div>
                                <div className='candidate-view-value'>
                                    {
                                        data.edu_cert_url ?
                                            <Link target='_blank' to={data.edu_cert_url} download>
                                                <Button type='primary' icon={<DownloadOutlined />}>Download</Button>
                                            </Link> : 'Not Available'
                                    }
                                </div>
                            </div>
                            <div className='candidate-view-info'>
                                <div className='candidate-view-label'>Experience Certificates</div>
                                <div className='candidate-view-value'>
                                    {
                                        data.exp_cert_url ?
                                            <Link target='_blank' to={data.exp_cert_url} download>
                                                <Button type='primary' icon={<DownloadOutlined />}>Download</Button>
                                            </Link> : 'Not Available'
                                    }

                                </div>
                            </div>
                            <div className='candidate-view-info'>
                                <div className='candidate-view-label'>Training Certificates</div>
                                <div className='candidate-view-value'>
                                    {
                                        data.training_cert_url ?
                                            <Link target='_blank' to={data.training_cert_url} download>
                                                <Button type='primary' icon={<DownloadOutlined />}>Download</Button>
                                            </Link> : 'Not Available'
                                    }
                                </div>
                            </div>
                            <div className='candidate-view-info'>
                                <div className='candidate-view-label'>Other Certificates</div>
                                <div className='candidate-view-value'>
                                    {
                                        data.other_cert_url ?
                                            <Link target='_blank' to={data.other_cert_url} download>
                                                <Button type='primary' icon={<DownloadOutlined />}>Download</Button>
                                            </Link> : 'Not Available'
                                    }
                                </div>
                            </div>
                        </div> */}

                        <div className='candidate-view'>
                            {
                                downloadCertificateButtons.map(item =>
                                    <>
                                        <div className='candidate-view-info'>
                                            <div className='candidate-view-label'>{item.title}</div>
                                            <div className='candidate-view-value'>
                                                {
                                                    item.url ?
                                                        <Button type='primary' icon={<DownloadOutlined />} onClick={() => handleFileDownload(item.url, item.title)}>Download</Button> :
                                                        'Not Available'
                                                }
                                            </div>
                                        </div>

                                    </>
                                )
                            }
                        </div>

                    </div>
                    <div className="col-md-4">

                        <div className='view-status'>
                            <span>Application Status : </span>
                            {
                                getStatusTag(data.status)
                            }
                        </div>
                        <div className="agency-details-box mt-4">
                            <h4 class="fw-semibold mb-3"><span>Contract Details</span></h4>
                            <div className='agency-view'>
                                <div className='agency-view-info'>
                                    <div className="agency-view-label">Agency Name</div>
                                    <div className="agency-view-value">{data.agency_name}</div>
                                </div>
                                <div className='agency-view-info'>
                                    <div className="agency-view-label">Unit Name</div>
                                    <div className="agency-view-value">{data.unit_name}</div>
                                </div>
                                <div className='agency-view-info'>
                                    <div className="agency-view-label">Contractor Type</div>
                                    <div className="agency-view-value">{data.contract_type}</div>
                                </div>
                                <div className='agency-view-info'>
                                    <div className="agency-view-label">Contractor PO No.</div>
                                    <div className="agency-view-value">{data.contractor_po_number}</div>
                                </div>
                                <div className='agency-view-info'>
                                    <div className="agency-view-label">Department Name</div>
                                    <div className="agency-view-value">{data.department}</div>
                                </div>
                                <div className='agency-view-info'>
                                    <div className="agency-view-label">Function Name</div>
                                    <div className="agency-view-value">{data.function_name}</div>
                                </div>
                                {/* <div className='agency-view-info'>
                                    <div className="agency-view-label">Work Area Name</div>
                                    <div className="agency-view-value">{data.work_area}</div>
                                </div> */}
                                <div className='agency-view-info'>
                                    <div className="agency-view-label">Section Name</div>
                                    <div className="agency-view-value">{data.section_name}</div>
                                </div>


                                {/* <div className='agency-view-info'>
                                    <div className="agency-view-label">Duty Position</div>
                                    <div className="agency-view-value">{data.duty_position}</div>
                                </div> */}
                                <div className='agency-view-info'>
                                    <div className="agency-view-label">Agency Supervisor</div>
                                    <div className="agency-view-value">{data.supervisor_name}</div>
                                </div>
                                <div className='agency-view-info'>
                                    <div className="agency-view-label">Agency Supervisor Mobile</div>
                                    <div className="agency-view-value">{data.supervisor_mobile_country_code
                                    } {data.supervisor_mobile}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='text-center'>
                    <Button className='mt-5' icon={<ArrowLeftOutlined />} onClick={() => navigate('/application-list')}>Go back</Button>
                </div>



                <Modal
                    open={showPreview}
                    title={previewTitle}
                    destroyOnClose
                    onCancel={handleClose}
                    footer={false}
                    style={{
                        top: 20,
                      }}              
                    width={isPdf ? 900 : 700}
                >
                    {
                        !isPdf ?
                            <div className='d-flex justify-content-center'>
                                <Image src={previewURL} style={{ maxWidth: '100%' }} />
                            </div> :
                            <>
                                <PDFViewer url={previewURL} />
                            </>

                    }

                    <div className='text-center mt-4'>
                        <Link target='_blank' to={previewURL} download>
                            <Button type='primary' size='large' icon={<DownloadOutlined />}>Download</Button>
                        </Link>
                    </div>
                </Modal>
            </Card >
        </>
    )
}

export default ApplicationDetails